import { render, staticRenderFns } from "./impressum.vue?vue&type=template&id=454590a0&scoped=true&"
import script from "./impressum.vue?vue&type=script&lang=js&"
export * from "./impressum.vue?vue&type=script&lang=js&"
import style0 from "./impressum.vue?vue&type=style&index=0&id=454590a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454590a0",
  null
  
)

export default component.exports